const checkLogin = (user) =>
    !!user
    && typeof user === 'object'
    && typeof user._id === 'string'

export default checkLogin